import React, { useState, useEffect } from 'react';
import './MobileEditGroup.css';

function MobileEditGroup({ isOpen, onClose, group, onUpdateGroup }) {
  const [name, setName] = useState('');
  const [context, setContext] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  // Populate form when group changes
  useEffect(() => {
    if (group) {
      setName(group.name || '');
      setContext(group.context || '');
      setError('');
    }
  }, [group]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError('Group name is required');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await onUpdateGroup(group.id, {
        name: name.trim(),
        context: context.trim() || null
      });
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to update group');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen || !group) return null;

  return (
    <div className="edit-group-overlay" onClick={onClose}>
      <div className="edit-group-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="edit-group-handle" />

        <h2 className="edit-group-title">Edit Group</h2>

        <div className="edit-group-field">
          <label className="edit-group-label">Name</label>
          <input
            type="text"
            className="edit-group-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter group name..."
          />
        </div>

        <div className="edit-group-field">
          <label className="edit-group-label">
            Context
            <span className="edit-group-optional">helps AI understand this group</span>
          </label>
          <textarea
            className="edit-group-textarea"
            value={context}
            onChange={(e) => setContext(e.target.value)}
            placeholder="Describe this group's purpose..."
            rows={4}
          />
          <p className="edit-group-hint">
            Examples: "Major donor prospects for our building campaign" or "Board members to cultivate for annual fund"
          </p>
        </div>

        {error && (
          <div className="edit-group-error">{error}</div>
        )}

        <div className="edit-group-actions">
          <button
            className="edit-group-cancel"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="edit-group-save"
            onClick={handleSubmit}
            disabled={isSubmitting || !name.trim()}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileEditGroup;
